import { render, staticRenderFns } from "./CampaignsTableRow.vue?vue&type=template&id=33549892&scoped=true&"
import script from "./CampaignsTableRow.vue?vue&type=script&lang=js&"
export * from "./CampaignsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsTableRow.vue?vue&type=style&index=0&id=33549892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33549892",
  null
  
)

export default component.exports